<mat-toolbar class="navbar-header mat-elevation-z4" color="primary">
  <img src="../../assets/img/LogoFlat.svg" alt="Avrae" />
  <div class="title">COMMANDS UI</div>
</mat-toolbar>
